export interface GitmapTheme {
    id: string;
    name: string;
    light: [string, string, string, string];
    dark: [string, string, string, string];
}

export const GITMAP_THEMES: GitmapTheme[] = [
    {
        id: "github",
        name: "GitHub",
        light: ["#9be9a8", "#40c463", "#30a14e", "#216e39"],
        dark: ["#0e4429", "#006d32", "#26a641", "#39d353"],
    },
    {
        id: "halloween",
        name: "Halloween",
        light: ["#fcdc8a", "#fbb14b", "#e35b1c", "#7e2400"],
        dark: ["#4a2a05", "#7a3f0c", "#a85a1c", "#c87c2a"],
    },
    {
        id: "winter",
        name: "Winter",
        light: ["#cfe7ff", "#7ab8ff", "#3a82e0", "#0a4ba0"],
        dark: ["#10243f", "#1c4170", "#2c629c", "#4a86c4"],
    },
    {
        id: "ocean",
        name: "Ocean",
        light: ["#bfe9e6", "#5fb6c4", "#3479a8", "#163d6b"],
        dark: ["#0f2733", "#1f4a5c", "#356d83", "#4f8fa3"],
    },
    {
        id: "sunset",
        name: "Sunset",
        light: ["#ffd5c2", "#f29c8a", "#bd5e6e", "#6f2a3a"],
        dark: ["#3a1318", "#5e2530", "#8c3f4d", "#b25e6c"],
    },
    {
        id: "forest",
        name: "Forest",
        light: ["#bcd6c4", "#6fa784", "#3f7a5a", "#1f4731"],
        dark: ["#13291d", "#264a36", "#3e6a52", "#5a8c70"],
    },
    {
        id: "lavender",
        name: "Lavender",
        light: ["#d8c5f0", "#a784e0", "#7a4dcf", "#3e2370"],
        dark: ["#1d1238", "#33255c", "#4d3a85", "#6c55b0"],
    },
    {
        id: "cherry",
        name: "Cherry",
        light: ["#fbcfd8", "#ee6e8d", "#c52a4a", "#6b0e22"],
        dark: ["#33101b", "#5e1d2f", "#8c2e48", "#b3445e"],
    },
    {
        id: "mint",
        name: "Mint",
        light: ["#c4eddc", "#79cfb1", "#3aa07c", "#1a5641"],
        dark: ["#0f2e25", "#1f5240", "#327260", "#4f9683"],
    },
    {
        id: "coral",
        name: "Coral",
        light: ["#ffd2bd", "#ff8c69", "#d3502a", "#6f1f0a"],
        dark: ["#3a1408", "#5e2614", "#8a3f24", "#b06138"],
    },
    {
        id: "slate",
        name: "Slate",
        light: ["#cfd6df", "#8c98aa", "#566273", "#2a323e"],
        dark: ["#1c2128", "#2c333d", "#444d5c", "#637180"],
    },
    {
        id: "gold",
        name: "Gold",
        light: ["#fbe69a", "#f0c14b", "#bf8a1a", "#5e4108"],
        dark: ["#33260a", "#5a4413", "#856820", "#b08c30"],
    },
    {
        id: "neon",
        name: "Neon",
        light: ["#a8fff1", "#34e3cf", "#0aa898", "#055f55"],
        dark: ["#0e2f2c", "#13524c", "#1e7a72", "#2da39a"],
    },
    {
        id: "rose",
        name: "Rose",
        light: ["#fbd1da", "#ee7a96", "#c42c5a", "#680e2a"],
        dark: ["#33121d", "#5a2034", "#85304e", "#b04d6f"],
    },
];

export const DEFAULT_THEME_ID = "github";

export function getTheme(id: string): GitmapTheme {
    return GITMAP_THEMES.find((t) => t.id === id) ?? GITMAP_THEMES[0];
}
